<template>
  <section>
    <modal-open-contact :dataCompanyModal="dataCompanyModal"/>
    <!-- top-menu -->
    <top-menu/>

    <div class="page-content cancel-detail-content">
      <div class="container-fluid">
        <div class="page-content-inner">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingListCancel"/>
            <!-- List Details -->
            <div v-if="!loadingListCancel" class="col-md-12 box-default">
              <div class="col-md-12 cancel-detail-card">
                <div class="cancel-detail-card-header">
                  <div class="title-cancel-detail">
                    <label class="label-icon-cancel-detail">
                      <ion-icon name="close-circle-outline"></ion-icon>
                      Detalhes de cancelamento
                    </label>
                    <span>Acompanhe todos os detalhes de cancelamentos</span>
                  </div>
                  <span class="cancel-detail-total">
                    Quantidade total ({{ dataContent.length }})
                    <a class="btn-excel" v-on:click="downloadExcel()">
                      <ion-icon name="document-outline"></ion-icon>
                      <span>Gerar Excel</span>
                    </a>
                  </span>
                </div>
                <div class="card-form-group">
                  <form v-on:submit.prevent="getListFilter()">
                    <div class="row">
                      <div class="table-box--form">
                        <div class="form-text-group col-md-3">
                          <label>Id da empresa</label>
                          <div class="form-text-default">
                            <input v-model="companyIdFilter" type="text" placeholder="Digite um id"
                                   autocomplete="off">
                            <ion-icon name="search-outline"></ion-icon>
                          </div>
                        </div>
                        <div class="form-text-group col-md-3">
                          <label>Nome da empresa</label>
                          <div class="form-text-default">
                            <input v-model="companyNameFilter" type="text" placeholder="Digite um nome"
                                   autocomplete="off">
                            <ion-icon name="search-outline"></ion-icon>
                          </div>
                        </div>
                        <div class="form-datepicker-group col-md-3">
                          <label>Data Inicial</label>
                          <div class="datepicker-group">
                            <datepicker v-model="dateInit" :language="ptBR" input-class="datepicker-style"
                                        :format="customFormatter"
                                        placeholder="DD/MM/YYYY"/>
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div class="form-datepicker-group col-md-3">
                          <label>Data Final</label>
                          <div class="datepicker-group">
                            <datepicker v-model="dateEnd" :language="ptBR" input-class="datepicker-style"
                                        :format="customFormatter"
                                        placeholder="DD/MM/YYYY"/>
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                      <div class="form-button col-md-2">
                        <button type="submit">Pesquisar</button>
                      </div>
                    </div>
                  </form>
                </div>
                <full-loading class="full-loading-list" v-if="loadingListFilter"/>
                <div v-if="!loadingListFilter" class="cancel-detail-card-content">
                  <div v-if="dataContent.length === 0" class="empty-state-group">
                    <img src="../../../../assets/img/empty-state.png" alt="empty-state">
                    <div class="empty-state-text">
                      <span class="empty-state-title">Nenhum cancelamento encontrado</span>
                      <span class="empty-state-subtitle">Caso esteja realizando alguma pesquisa, verifique os dados preenchidos e tente novamente!</span>
                    </div>
                  </div>
                  <table v-else class="cancel-detail-table">
                    <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Solicitante</th>
                      <th>Solicitado em</th>
                      <th>Motivos</th>
                      <th>Arquivos fiscais?</th>
                      <th>Nome de contato</th>
                      <th>Telefone</th>
                      <th>Horário de contato</th>
                      <th>Feedback</th>
                      <th>Outro motivo</th>
                      <th>Outro concorrente</th>
                      <th>Contato realizado</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in dataContent">
                      <td class="company-name">
                        <a :href="'/detalhes-da-empresa/' + value.companyId + '/' + value.contextCode" target="_blank"
                           :title="value.companyName">{{ value.companyName }}</a>
                      </td>
                      <td class="requester-name">
                        <span :title="value.userName">{{ value.userName }}</span>
                      </td>
                      <td class="requested-at">
                        {{ value.createdAt | formatDate }} <span> às {{ value.createdAt | formatHors24Z }} </span>
                      </td>
                      <td class="experiences">
                        <span :title="value.experiences">{{ value.experiences }}</span>
                      </td>
                      <td class="want-files">
                        {{ value.cancelFilesStr }}
                      </td>
                      <td class="contact-name">
                        <span :title="value.contact.name">{{ value.contact.name }}</span>
                      </td>
                      <td class="phone">
                        <span :title="value.contact.cellphone">{{ value.contact.cellphone }}</span>

                      </td>
                      <td class="contact-time">
                        <span :title="value.contact.contactHour">{{ value.contact.contactHour }}</span>
                      </td>
                      <td class="feedback">
                        <span :title="value.feedback">
                          {{ value.feedback }}
                        </span>
                      </td>
                      <td class="reason">
                        <span :title="value.motive">
                          {{ value.motive }}
                        </span>
                      </td>
                      <td class="another-competitor">
                        <span :title="value.anotherCompeting">
                          {{ value.anotherCompeting }}
                        </span>
                      </td>
                      <td class="td-contact">
                        <a v-if="value.contactDone === false" class="disabled-tag"
                           @click="registerContact(value)">Não</a>
                        <a v-else class="active-tag" @click="registerContact(value)">Sim</a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <footer-menu v-if="!loadingListCancel"/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import footerMenu from "../../components/default/footerMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import {GET_CANCEL_DETAILS, GET_CANCEL_DETAILS_V2, ORDERS_BENEFITS} from "../../../../urlConfig";
import {UTIL_SERVICE} from "../../../../utils";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import moment from "moment";

import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import modalOpenContact from "../../modals/modalOpenContact.vue";

export default {
  name: "cancelDetail",
  components: {
    modalOpenContact,
    topMenu,
    footerMenu,
    fullLoading,
    datepicker
  },
  data() {
    return {
      ptBR: ptBR,
      loadingListCancel: false,
      loadingListFilter: false,
      dataContent: '',
      companyIdFilter: '',
      companyNameFilter: '',
      dateEnd: '',
      dateInit: '',
      dataCompanyModal: ''
    }
  },
  methods: {
    registerContact(value) {
      this.dataCompanyModal = {};
      this.dataCompanyModal.companyName = value.companyName;
      this.dataCompanyModal.id = value.id;
      this.dataCompanyModal.contactText = value.contactText;
      this.dataCompanyModal.companyId = value.companyId;
      this.dataCompanyModal.contactDone = value.contactDone;
      this.dataCompanyModal.context = value.contextCode;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);
      this.dataCompanyModal.pageCancelation = true;

      $("#modalOpenContact").modal();
    },
    getCancelDetails() {
      this.loadingListCancel = true;

      let url = GET_CANCEL_DETAILS_V2;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_CANCEL_DETAILS:", response.data);
          this.dataContent = response.data;

          this.loadingListCancel = false;
        })
        .catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);

          this.loadingListCancel = false;
        });
    },
    getListFilter() {
      this.loadingListFilter = true;
      const url = GET_CANCEL_DETAILS_V2;

      let objSend = {};

      if (this.companyIdFilter)
        objSend.companyId = this.companyIdFilter;

      if (this.companyNameFilter)
        objSend.companyName = this.companyNameFilter;

      if (this.dateInit) {
        this.dateInit = moment(this.dateInit).format('YYYY-MM-DD');

        objSend.initDate = this.dateInit;
      }

      if (this.dateEnd) {
        this.dateEnd = moment(this.dateEnd).format('YYYY-MM-DD');

        objSend.endDate = this.dateEnd;
      }

      const newUrl = url + '?' + new URLSearchParams(objSend).toString()

      UTIL_SERVICE.console("URL SEARCH:", objSend);
      REQUEST_SERVICE.get(newUrl).then((response) => {
        UTIL_SERVICE.console("RESULT ORDERS_BENEFITS:", response.data);

        this.dataContent = response.data;
        this.loadingListFilter = false;
      }).catch((reason) => {
        this.loadingListFilter = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    downloadExcel() {
      let bodyValue = [];
      let headValue = ["Empresa", "Solicitante", "Solicitado em:", "Motivos", "Arquivos fiscais?", "Nome de contato", "Telefone", "Horário de contato", "Feedback", "Outro motivo", "Outro concorrente", "Ip"];

      this.dataContent.map((value) => {
        bodyValue.push([value.companyName, value.userName, moment(String(value.createdAt)).format('DD/MM/YYYY HH:mm'), value.experiences, value.cancelFilesStr, value.contact.name, value.contact.cellphone, value.contact.contactHour, value.feedback, value.motive, value.anotherCompeting, value.ip]);
      });

      window.downloadListExcel(headValue, bodyValue, "Lista de cancelamentos");
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
  beforeMount() {
    this.getCancelDetails();
  },

}
</script>

<style lang="scss">

.cancel-detail-content {
  .box-default {
    border-radius: 10px !important;
    padding: 20px 30px;
    background: #ffffff;
    min-height: 58rem;

    .cancel-detail-card {
      padding: 0;

      .full-loading-list {
        border: none;
        box-shadow: none;
      }

      .cancel-detail-card-header {
        display: flex;
        justify-content: space-between;

        .title-cancel-detail {
          padding: 0;

          .label-icon-cancel-detail {
            margin: 0;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);

            ion-icon {
              margin-right: 5px;
              font-size: 23px;
              color: var(--dark-gray);
            }
          }

          span {
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .cancel-detail-total {
          position: relative;

          color: var(--dark-gray);
          font-size: 16px;
          font-weight: 500;

          .btn-excel {
            position: absolute;
            bottom: -15px;
            right: 0;

            display: flex;
            align-items: center;

            padding: 4px 20px;
            background: var(--light-green);
            color: #ffffff;
            border-radius: 4px !important;
            border: none;
            text-decoration: none;

            &:hover {
              background: #17a24f;
            }

            span {
              font-size: 14px;
            }

            ion-icon {
              margin-right: 5px;
            }
          }
        }
      }

      .card-form-group {
        margin-top: 30px;
        margin-bottom: 60px;

        .table-box--form {
          display: flex;
          margin-top: 25px;

          &:last-of-type {
            margin-top: 15px;
          }

          .form-text-group {
            display: flex;
            flex-direction: column;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .form-text-default {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .form-datepicker-group {
            display: flex;
            flex-direction: column;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .datepicker-group {
              position: relative;

              .vdp-datepicker {
                display: inline-block;
                width: 100%;

                .datepicker-style {
                  width: 100%;
                  background: #EEF2F7;
                  border-radius: 4px !important;
                  padding: 6px 12px;
                  border: 1px solid #EEF2F7;
                  transition: .2s;

                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);

                  &::placeholder {
                    font-size: 16px;
                    font-weight: 400;
                    color: var(--dark-gray);
                  }

                  &:hover {
                    transition: .2s;
                    border: 1px solid #cacaca;
                  }

                  &:focus-visible {
                    outline: none;
                    transition: .2s;
                    border: 1px solid #cacaca;

                    &::placeholder {
                      transition: .1s;
                      color: #EEF2F7;
                    }
                  }
                }
              }

              i {
                position: absolute;
                right: 15px;
                top: 11px;
                color: #111;
                cursor: pointer;
              }
            }
          }

          .form-select {
            display: flex;
            flex-direction: column;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .form-select-input {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;
              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }
        }

        .form-button {
          padding-right: 0;

          button {
            margin-top: 25.5px;
            background: #2F23D6;
            color: #ffffff;
            border-radius: 4px !important;
            border: none;
            padding: 8px 59.5px;

            &:hover {
              background: #20179e;
            }
          }
        }
      }

      .cancel-detail-card-content {
        overflow: auto;

        .empty-state-group {
          text-align: center;
          margin-top: 2rem;
          margin-bottom: 6rem;

          img {
            margin-bottom: 2rem;
          }

          .empty-state-text {
            display: flex;
            justify-content: center;
            flex-direction: column;

            width: 45%;
            margin: auto;

            .empty-state-title {
              font-weight: 700;
              font-size: 16px;
              color: var(--dark-gray);
            }

            .empty-state-subtitle {
              font-weight: 400;
              font-size: 16px;
              color: var(--dark-gray);
            }
          }
        }

        .cancel-detail-table {
          position: relative;

          width: 100%;
          margin-bottom: 20px;

          thead {
            position: sticky;
            top: 0;

            font-size: 14px;
            color: var(--high-gray);
            line-height: 220%;
            padding-bottom: 5px;
            border-bottom: 1px solid var(--classic-gray);
            background: var(--classic-white);

            tr {
              th {
                font-weight: 500 !important;
                line-height: 100%;
                padding-bottom: 10px;
              }
            }
          }

          tbody {
            tr {
              border-bottom: 1px solid var(--classic-gray);

              .company-name {
                color: var(--dark-gray);
                padding: 20px 0;

                a {
                  display: list-item;
                  width: 140px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  font-size: 14px;
                  font-weight: 500;
                  color: var(--high-blue);
                  align-items: center;
                }
              }

              .requester-name {
                color: var(--dark-gray);
                padding-right: 16px;

                span {
                  display: list-item;
                  width: 100px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .requested-at {
                display: flex;
                flex-direction: column;
                margin-top: 11px;
                margin-right: 11px;

                font-size: 14px;
                font-weight: 400;
                color: var(--dark-gray);
                padding: 0 20px 0 10px;

                span {
                  font-size: 12px;
                  font-weight: 400;
                  color: var(--high-gray);
                }
              }

              .experiences {
                //width: 10%;
                color: var(--dark-gray);

                span {
                  display: list-item;
                  width: 110px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .want-files {
                color: var(--dark-gray);
                padding: 0 35px 0 16px;
              }

              .contact-name {
                color: var(--dark-gray);
                padding-right: 10px;

                span {
                  display: list-item;
                  width: 80px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .phone {
                color: var(--dark-gray);

                span {
                  display: list-item;
                  width: 140px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .contact-time {
                color: var(--dark-gray);
                padding-right: 10px;

                span {
                  display: list-item;
                  width: 100px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .feedback {
                color: var(--dark-gray);

                span {
                  display: list-item;
                  width: 110px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .reason {
                color: var(--dark-gray);

                span {
                  display: list-item;
                  width: 110px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .another-competitor {
                color: var(--dark-gray);

                span {
                  display: list-item;
                  width: 120px;
                  white-space: nowrap;
                  overflow: hidden !important;
                  text-overflow: ellipsis;
                  align-items: center;
                }
              }

              .td-contact {
                width: 60px;

                .disabled-tag,
                .active-tag {
                  background: #e8505b;
                  color: #ffffff;
                  display: block;
                  width: 126px;
                  text-align: center;
                  border-radius: 4px !important;
                  height: 24px;
                  padding: 0 10px;
                  line-height: 25px;

                  &:hover {
                    color: #ffffff;
                    text-decoration: none;
                  }
                }

                .active-tag {
                  background: #00a651;
                }
              }
            }
          }
        }
      }

      .cancel-detail-card-content::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        position: absolute;
      }

      .cancel-detail-card-content::-webkit-scrollbar-track {
        background-color: #e6e9ec;
        border-radius: 6px;
      }

      .cancel-detail-card-content::-webkit-scrollbar-thumb {
        background: #3a424e;
        border-radius: 6px;
      }

      .cancel-detail-card-content::-webkit-scrollbar-thumb:hover {
        background: lighten(#3a424e, 5%);
        transition: 0.5s;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/cancelDetail.vue